import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiShield, FiTarget, FiHeart } = FiIcons;

const BenefitsSection = () => {
  const benefits = [
    {
      icon: FiCalendar,
      title: "คู่มือชีวิต 24 ซีซั่น",
      description: "เรียนรู้วิธีแบ่งจังหวะชีวิตให้สอดคล้องกับพลังงานธรรมชาติ รู้ว่าเมื่อไหร่ควรเร่ง, เมื่อไหร่ควรผ่อน, และเมื่อไหร่ควรพัก"
    },
    {
      icon: FiShield,
      title: "วิธีเอาชนะ Burnout อย่างถาวร",
      description: "ทำความเข้าใจต้นตอของความเหนื่อยล้า และสร้างเกราะป้องกันภาวะหมดไฟในระยะยาว"
    },
    {
      icon: FiTarget,
      title: "เทคนิคการตัดสินใจที่เฉียบคม",
      description: "ใช้ \"ฤดูกาล\" เป็นกรอบความคิดในการตัดสินใจเรื่องสำคัญ ทั้งเรื่องงาน, ความสัมพันธ์, และการใช้ชีวิต"
    },
    {
      icon: FiHeart,
      title: "การกลับมาเชื่อมต่อกับตัวเอง",
      description: "ค้นพบความสงบจากภายใน และเปลี่ยนความวุ่นวายให้กลายเป็นพลังบวก"
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-8" style={{ fontFamily: 'Kanit, sans-serif' }}>
            สิ่งที่คุณจะได้รับจากหนังสือเล่มนี้:
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group p-8 rounded-2xl bg-gradient-to-br from-[#F5F5F5] to-white border border-[#E0E0E0] hover:shadow-xl hover:border-[#E07A5F] transition-all duration-300"
            >
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 p-4 rounded-full bg-gradient-to-br from-[#556B2F] to-[#6082B6] group-hover:scale-110 transition-transform duration-300">
                  <SafeIcon 
                    icon={benefit.icon} 
                    className="text-2xl text-white" 
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#333333] mb-4 group-hover:text-[#556B2F] transition-colors duration-300" style={{ fontFamily: 'Kanit, sans-serif' }}>
                    {benefit.title}
                  </h3>
                  <p className="text-[#666666] leading-relaxed" style={{ fontFamily: 'Sarabun, serif' }}>
                    {benefit.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;